export default __webpack_public_path__ + "static/media/def-tech.078f0c87.png";